<template>
   <div v-if="intersected">
      <slot />
   </div>
   <div v-else />
</template>

<script>
export default {
   data: () => ({
      intersected: false,
      observer: null,
   }),
   mounted() {
      if ('IntersectionObserver' in window) {
         this.observer = new IntersectionObserver((entries) => {
            const element = entries[0];
            if (element.isIntersecting && !this.intersected) {
               this.intersected = true;
               this.observer.disconnect();
            }
         });

         this.observer.observe(this.$el);
      } else {
         this.intersected = true;
      }
   },
   destroyed() {
      this.observer && this.observer.disconnect();
   },
};
</script>
